/* eslint-disable react/prop-types */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Library===================
import PropTypes from 'prop-types';
import {
  CircleMarker,
  MapContainer,
  Popup,
  TileLayer,
} from 'react-leaflet';

// ==================React Hooks===================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

// ==================Style&IMG===================
import './style.scss';

// ==================Components===================
import NodeInfoArray from './NodeInfoArray';

// ===================ACTIONS======================
import { setSaveNodeInfoMakerComponent } from '../../../actions/nodeInfo';

function NodeInfoMap({ nodeInfoMap }) {
  const dispatch = useDispatch();
  const center = useSelector((state) => state.site.map.center);
  const mapURL = useSelector((state) => state.site.map.mapURL);
  const markerComponent = useSelector((state) => state.nodeInfo.nodeInfoPage.markerComponent);
  // function to create popup with information for single or multiple station
  // eslint-disable-next-line consistent-return
  function createPopup(element) {
    let multipleDataPopup = false;
    for (let i = 0; i < nodeInfoMap.map_node.length; i += 1) {
      multipleDataPopup = false;
      if (nodeInfoMap.map_node[i].value.Lat === element.value.Lat
        && nodeInfoMap.map_node[i].value.Lon === element.value.Lon) {
        if (nodeInfoMap.map_node[i].value.Name !== element.value.Name) {
          multipleDataPopup = true;
        }
        if (!multipleDataPopup) {
          return (
            <Popup>
              <div className="popup-single-station">
                <div className="station-1">
                  <ul>
                    <li><strong>Name: </strong>{element.value.Name}</li>
                    <li><strong>Lat: </strong>{element.value.Lat}</li>
                    <li><strong>Lon: </strong>{element.value.Lon}</li>
                    <li><strong>Adress: </strong>{element.value.Address}</li>
                    <li><strong>Link: </strong><a href={element.value.Link} rel="noreferrer" target="_blank">{element.value.Name}</a></li>
                  </ul>
                </div>
              </div>
            </Popup>
          );
        }
        return (
          <Popup>
            <div className="popup-single-station">
              <div className="station-1">
                <ul>
                  <li>
                    <strong>
                      Name:
                    </strong>
                    {element.value.Name} && {nodeInfoMap.map_node[i].value.Name}
                  </li>
                  <li><strong>Lat: </strong>{element.value.Lat}</li>
                  <li><strong>Lon: </strong>{element.value.Lon}</li>
                  <li><strong>Adress: </strong>{element.value.Address}</li>
                  <li><strong>Link: </strong><a href={element.value.Link} rel="noreferrer" target="_blank">{element.value.Name}</a></li>
                  <li><strong>Link: </strong><a href={nodeInfoMap.map_node[i].value.Link} rel="noreferrer" target="_blank">{nodeInfoMap.map_node[i].value.Name}</a></li>
                </ul>
              </div>
            </div>
          </Popup>
        );
      }
    }
  }
  // when launching the page creation of markers with radius and popup positioning
  useEffect(() => {
    let markerComponents = [];
    let multipleMarker;
    markerComponents = nodeInfoMap.map_node.map((marker) => {
      multipleMarker = false;
      for (let i = 0; i < nodeInfoMap.map_node.length; i += 1) {
        if (nodeInfoMap.map_node[i].value.Lat === marker.value.Lat
          && nodeInfoMap.map_node[i].value.Lon === marker.value.Lon) {
          if (nodeInfoMap.map_node[i].value.Name !== marker.value.Name) {
            multipleMarker = true;
          }
        }
      }
      if (multipleMarker) {
        return (
          <CircleMarker
            key={marker.id}
            center={[marker.value.Lat, marker.value.Lon]}
            radius={5}
            pathOptions={{ color: 'green' }}
          >
            {createPopup(marker)}
          </CircleMarker>
        );
      }
      if (multipleMarker === false) {
        return (
          <CircleMarker
            key={marker.id}
            center={[marker.value.Lat, marker.value.Lon]}
            radius={5}
          >
            {createPopup(marker)}
          </CircleMarker>
        );
      }
      return null;
    });
    if (markerComponents.length !== 0) {
      dispatch(setSaveNodeInfoMakerComponent(markerComponents));
    }
  }, []);
  return (
    <div className="nodeInfoMap">
      <h1 id="title1">EPOS GNSS Node Infrastructure</h1>
      <div className="nodeInfoMap--container">
        <MapContainer
          center={center}
          zoom={3}
          minZoom={2}
          style={{ width: '50%', minHeight: '100%' }}
        >
          <div className="nodeinfo--legend">
            <div className="nodeinfo--width">
              <div>
                <div className="single--node" />
                <p>single node</p>
              </div>
              <div>
                <div className="multiple--node" />
                <p>multiple node</p>
              </div>
            </div>
          </div>

          <TileLayer
            url={mapURL}
          />
          {(markerComponent.length !== 0) && markerComponent}
        </MapContainer>
        <NodeInfoArray header={nodeInfoMap.header_table_node} content={nodeInfoMap.map_node} />
      </div>

    </div>
  );
}

NodeInfoMap.propTypes = {
  nodeInfoMap: PropTypes.shape({
    map_node: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.shape({
          Lat: PropTypes.number,
          Lon: PropTypes.number,
        }),
      }),
    ),
  }).isRequired,
};

export default NodeInfoMap;
